import Vue from 'vue';
import Page from './page/main.vue';
import router from '@/entries/widget/router/router.js';
import { i18n } from './i18n.js';

import store from "@/entries/widget/store";


new Vue({
    store,
    el: "#app",
    render: h => h(Page),
    i18n,
    router
});
